import React from 'react';
import classnames from 'classnames';

type Props = {
    value: any;
    onChange?: (data: any) => void;
}

export default (props: Props) => {
    const { value, onChange } = props;

    // if (!value) {
    //     onChange({});
    //     return null;
    // }

    const onLengthChange = (e) => {
        onChange({...value.value, length: e.currentTarget.value});
    }

    const onWidthChange = (e) => {
        onChange({...value.value, width: e.currentTarget.value});
    }

    return <div className="field  is-horizontal">
                <div className="field-label is-normal">
                    <label className="label">Größe</label>
                </div>
                <div className="field-body">
                    <div className="field">
                        <div className="control">

                            <div className="field has-addons">
                                <div className="control">
                                    <input name="sizeWidth" className={classnames(["input", value.error ? "is-danger" : ""])} type="number" placeholder="Breite" value={(value.value.length) ? value.value.length : ""} onChange={onLengthChange} />
                                </div>
                                <p className="control">
                                    <span className="button is-static">
                                        x
                                    </span>
                                </p>
                                <p className="control">
                                    <input name="sizeHeight" className={classnames(["input", value.error ? "is-danger" : ""])} type="number" placeholder="Höhe" value={(value.value.width) ? value.value.width : ""} onChange={onWidthChange} />
                                </p>
                                <p className="control">
                                    <span className="button is-static">
                                    in  cm
                                    </span>
                                </p>
                            </div>

                        </div>
                        {value.error && <div className="field-body">
                            <p className="help is-danger">{value.error}</p>
                        </div>}
                    </div>
                    
                   
                </div>
            </div>;
}